import { FaReact, FaNodeJs, FaJava, FaHtml5, FaJs, FaPython} from "react-icons/fa";

export const softwareDevelopmentData = [
  {
    id: 7,
    title: 'Software Development',
    category: 'Software Development',
    description: 'Innovative software solutions tailored to your business needs. We develop custom web and mobile applications that increase our customers’ competitive advantage and improve their business efficiency.',
    image: '/img/services_img/7/1.png',
    sub_headers: {
      title: "Software Development",
      sub_points: [
        "Innovative software solutions.",
        "Tailored to your business needs.",
        "Increase customers’ competitive advantage.",
        "Improve business efficiency."
      ],
      mockupImage: "/img/services_img/7/2.png",
    },
    problem: {
      challenges: [
        "Keeping up with rapidly evolving technologies and frameworks.",
        "Ensuring scalability and maintainability of complex software systems.",
        "Delivering high-quality software within tight deadlines and budget constraints."
      ],
      mockupImage: "/img/services_img/7/3.png",
    },
    solutions: {
      desc: "We tackle these challenges by adopting agile development methodologies, leveraging modern tech stacks, and implementing rigorous testing procedures. Our focus is on building robust, scalable, and user-centric software solutions that align with your business objectives.",
      points: [
        "Agile development and continuous integration.",
        "Modern tech stacks (e.g., React, Node.js, Python).",
        "Comprehensive testing and quality assurance.",
        "Scalable architecture design.",
        "User-centric design principles."
      ],
      mockupImage: "/img/services_img/7/4.png",
    },
    benefits: {
      desc: "Our custom software development services lead to increased operational efficiency, enhanced customer satisfaction, and a strong competitive advantage. We help you innovate faster and achieve your business goals with reliable and high-performing software.",
      metrics: [
        {
          title: "Operational Efficiency",
          value: "30%",
          extra: "increase",
        },
        {
          title: "Customer Satisfaction",
          value: "25%",
          extra: "improvement",
        },
        {
          title: "Time to Market",
          value: "20%",
          extra: "reduction",
        },
      ],
    },
    process: [
        {
            id: 1,
            title: "Discovery & Planning",
            description: "We begin by deeply understanding your vision, business objectives, and technical requirements. This phase involves comprehensive consultations and feasibility studies to define the project scope and outline a strategic roadmap."
        },
        {
            id: 2,
            title: "Design & Prototyping",
            description: "Our expert designers craft intuitive user interfaces and engaging user experiences. We develop interactive prototypes and wireframes, allowing you to visualize and refine the product's look and feel before development begins."
        },
        {
            id: 3,
            title: "Development & Testing",
            description: "Leveraging agile methodologies, our developers build robust and scalable solutions using cutting-edge technologies. Each module undergoes rigorous testing, including unit, integration, and user acceptance testing, to ensure flawless performance and reliability."
        },
        {
            id: 4,
            title: "Deployment & Training",
            description: "Upon successful completion and testing, we seamlessly deploy the software to your production environment. We also provide comprehensive training and documentation to your team, ensuring a smooth transition and optimal utilization of the new system."
        }
    ],
    features: [
      {
        id: 1,
        title: "Custom Web Applications",
        sub_features: [
          "Scalable and secure web platforms",
          "Responsive design for all devices",
          "Integration with third-party services"
        ]
      },
      {
        id: 2,
        title: "Enterprise Software",
        sub_features: [
          "CRM, ERP, and SCM solutions",
          "Business process automation",
          "Data analytics and reporting tools"
        ]
      },
    ],
    technologies: [
      { name: "React", icon: <FaReact className="text-blue-500 text-3xl" /> },
      { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
      { name: "Python", icon: <FaPython className="text-blue-500 text-3xl" /> },
      { name: "Java", icon: <FaJava className="text-red-500 text-3xl" /> },
    ],
    testimonials: [
        {
            id: 1,
            quote: "Techvelly delivered an outstanding software solution that perfectly met our complex business requirements. Their team was professional, highly skilled, and a pleasure to work with.",
            author: "John Doe",
            title: "CEO, Tech Solutions Inc."
        }
    ],
    faq: [
        {
            id: 1,
            question: "What industries do you serve?",
            answer: "We serve a wide range of industries including healthcare, finance, education, retail, and manufacturing."
        },
        {
            id: 2,
            question: "How do you ensure the security of the software?",
            answer: "We follow industry best practices for security, including regular code reviews, penetration testing, and adherence to data protection regulations."
        }
    ]
  },
  {
    id: 8,
    title: 'Web Development',
    category: 'Software Development',
    description: 'Robust web apps crafted for performance & user engagement. We build modern, responsive, and scalable web applications using the latest technologies.',
    image: '/img/services_img/8/1.png',
    sub_headers: {
      title: "Web Development",
      sub_points: [
        "Robust web apps.",
        "Crafted for performance & user engagement.",
        "Modern, responsive, and scalable.",
        "Built with latest technologies."
      ],
      mockupImage: "/img/services_img/8/2.png",
    },
    problem: {
      challenges: [
        "Building responsive and performant web applications that work seamlessly across all devices and browsers.",
        "Integrating complex backend systems and third-party APIs.",
        "Ensuring robust security and data protection for web applications."
      ],
      mockupImage: "/img/services_img/8/3.png",
    },
    solutions: {
      desc: "We specialize in developing modern web applications using cutting-edge technologies. Our approach focuses on creating highly interactive, secure, and scalable solutions that provide an exceptional user experience and meet your specific business requirements.",
      points: [
        "Frontend development with React, Angular, or Vue.js.",
        "Backend development with Node.js, Python (Django/Flask), or Java (Spring).",
        "Database design and management (SQL/NoSQL).",
        "API development and integration.",
        "Cloud deployment and DevOps practices."
      ],
      mockupImage: "/img/services_img/8/4.png",
    },
    benefits: {
      desc: "Our web development services help businesses establish a strong online presence, improve customer engagement, and streamline operations. We deliver web solutions that are not only visually appealing but also highly functional and secure.",
      metrics: [
        {
          title: "User Engagement",
          value: "35%",
          extra: "increase",
        },
        {
          title: "Website Performance",
          value: "40%",
          extra: "improvement",
        },
        {
          title: "Conversion Rate",
          value: "20%",
          extra: "increase",
        },
      ],
    },
    process: [
        {
            id: 1,
            title: "Discovery & Planning",
            description: "We initiate by thoroughly understanding your web project vision, target audience, and functional requirements. This phase involves in-depth discussions and market analysis to define the project scope and strategize the development roadmap."
        },
        {
            id: 2,
            title: "Design & Prototyping",
            description: "Our UI/UX experts craft visually appealing and highly functional designs. We create wireframes, mockups, and interactive prototypes to ensure the user experience is intuitive and aligns perfectly with your brand identity."
        },
        {
            id: 3,
            title: "Development & Testing",
            description: "Our development team builds your web application using modern frameworks and best practices, focusing on performance, security, and scalability. Rigorous testing phases, including functional, integration, and performance testing, guarantee a high-quality and bug-free product."
        },
        {
            id: 4,
            title: "Deployment & Training",
            description: "We handle the seamless deployment of your web application to chosen servers, ensuring optimal configuration and performance. Post-launch, we provide comprehensive training for your team and ongoing support to ensure smooth operation and continued success."
        }
    ],
    features: [
      {
        id: 1,
        title: "Custom Web Applications",
        sub_features: [
          "E-commerce platforms",
          "Content Management Systems (CMS)",
          "Customer Relationship Management (CRM)"
        ]
      },
      {
        id: 2,
        title: "API Development",
        sub_features: [
          "RESTful API development",
          "Third-party API integration",
          "Microservices architecture"
        ]
      },
    ],
    technologies: [
      { name: "React", icon: <FaReact className="text-blue-500 text-3xl" /> },
      { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
      { name: "HTML5", icon: <FaHtml5 className="text-orange-500 text-3xl" /> },
      { name: "JavaScript", icon: <FaJs className="text-yellow-400 text-3xl" /> },
    ],
    testimonials: [
        {
            id: 1,
            quote: "Techvelly transformed our outdated website into a modern, responsive, and highly functional platform. Their expertise in web development is truly commendable.",
            author: "Jane Smith",
            title: "Marketing Director, Global Corp."
        }
    ],
    faq: [
        {
            id: 1,
            question: "What web technologies do you specialize in?",
            answer: "We specialize in a range of modern web technologies including React, Angular, Vue.js for frontend, and Node.js, Python (Django/Flask), and Java (Spring) for backend development."
        },
        {
            id: 2,
            question: "Can you help with website maintenance and support?",
            answer: "Yes, we offer comprehensive post-development support and maintenance services to ensure your web application remains secure, up-to-date, and performs optimally."
        }
    ]
  },
  {
    id: 9,
    title: 'Mobile App Development',
    category: 'Software Development',
    description: 'Custom mobile apps built for performance and reliability. We create native and cross-platform mobile applications for iOS and Android.',
    image: '/img/services_img/9/1.png',
    sub_headers: {
      title: "Mobile App Development",
      sub_points: [
        "Custom mobile apps.",
        "Built for performance and reliability.",
        "Native and cross-platform.",
        "For iOS and Android."
      ],
      mockupImage: "/img/services_img/9/2.png",
    },
    problem: {
      challenges: [
        "Developing high-performance mobile applications that offer a seamless user experience across diverse devices and operating systems.",
        "Ensuring robust security and data privacy in mobile environments.",
        "Integrating complex backend services and third-party APIs while maintaining app responsiveness."
      ],
      mockupImage: "/img/services_img/9/3.png",
    },
    solutions: {
      desc: "We specialize in creating intuitive, secure, and scalable mobile applications for both iOS and Android platforms. Our development process emphasizes user-centric design, cutting-edge technology and rigorous testing to deliver apps that stand out.",
      points: [
        "Native iOS and Android app development.",
        "Cross-platform development with React Native or Flutter.",
        "Intuitive UI/UX design for mobile.",
        "Backend integration and API development.",
        "Performance optimization and rigorous testing."
      ],
      mockupImage: "/img/services_img/9/4.png",
    },
    benefits: {
      desc: "Our mobile app development services help businesses reach a wider audience, enhance customer engagement, and drive innovation. We deliver mobile solutions that are not only functional but also provide a delightful user experience.",
      metrics: [
        {
          title: "User Reach",
          value: "50%",
          extra: "expansion",
        },
        {
          title: "App Engagement",
          value: "45%",
          extra: "increase",
        },
        {
          title: "Customer Retention",
          value: "30%",
          extra: "improvement",
        },
      ],
    },
    process: [
        {
            id: 1,
            title: "Discovery & Planning",
            description: "We begin by analyzing your mobile app idea, target users, and market landscape. This phase includes detailed requirement gathering, competitor analysis, and defining a clear project scope and strategy for your mobile solution."
        },
        {
            id: 2,
            title: "Design & Prototyping",
            description: "Our design team crafts intuitive and engaging mobile user interfaces (UI) and experiences (UX). We develop wireframes, mockups, and interactive prototypes to visualize the app's flow and aesthetics, ensuring a user-centric design."
        },
        {
            id: 3,
            title: "Development & Testing",
            description: "Our skilled developers build your mobile application for iOS and Android platforms, focusing on performance, security, and scalability. We conduct extensive testing, including functional, usability, and compatibility tests, to deliver a robust and bug-free app."
        },
        {
            id: 4,
            title: "Deployment & Training",
            description: "We manage the entire app store submission process for both iOS and Android platforms. Following deployment, we provide comprehensive training to your team on app management and offer ongoing support and maintenance to ensure long-term success and user satisfaction."
        }
    ],
    features: [
      {
        id: 1,
        title: "Custom Mobile Applications",
        sub_features: [
          "Native iOS and Android apps",
          "Cross-platform apps (React Native, Flutter)",
          "Enterprise mobile solutions"
        ]
      },
      {
        id: 2,
        title: "Mobile UI/UX Design",
        sub_features: [
          "Intuitive and engaging interfaces",
          "User research and persona development",
          "Wireframing and prototyping"
        ]
      },
    ],
    technologies: [
      { name: "React Native", icon: <FaReact className="text-blue-500 text-3xl" /> },
      { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
      { name: "Java", icon: <FaJava className="text-red-500 text-3xl" /> },
      { name: "Python", icon: <FaPython className="text-blue-500 text-3xl" /> },
    ],
    testimonials: [
        {
            id: 1,
            quote: "The mobile app developed by Techvelly has significantly improved our customer engagement. Their team's dedication to quality and user experience is truly impressive.",
            author: "David Lee",
            title: "Founder, Mobile Innovations"
        }
    ],
    faq: [
        {
            id: 1,
            question: "What is the typical timeline for mobile app development?",
            answer: "The timeline varies based on complexity, but a basic app can take 3-6 months, while more complex applications may take 6-12 months or more."
        },
        {
            id: 2,
            question: "Do you provide post-launch support and maintenance?",
            answer: "Yes, we offer comprehensive support and maintenance packages to ensure your app remains updated, secure, and performs optimally after launch."
        }
    ]
  },
  {
    id: 10,
    title: 'UI/UX Design',
    category: 'Software Development',
    description: 'Intuitive designs focused on enhancing user interaction. We create beautiful and user-friendly interfaces that provide a great user experience.',
    image: '/img/services_img/10/1.png',
    sub_headers: {
      title: "UI/UX Design",
      sub_points: [
        "Intuitive designs.",
        "Focused on enhancing user interaction.",
        "Beautiful and user-friendly interfaces.",
        "Great user experience."
      ],
      mockupImage: "/img/services_img/10/2.png",
    },
    problem: {
      challenges: [
        "Creating intuitive and engaging user interfaces that align with business goals and user needs.",
        "Ensuring consistency across different platforms and devices.",
        "Translating complex functionalities into simple and user-friendly designs."
      ],
      mockupImage: "/img/services_img/10/3.png",
    },
    solutions: {
      desc: "Our UI/UX design process is centered around understanding your users and business objectives. We combine aesthetic appeal with functional design to create interfaces that are not only beautiful but also highly usable and accessible, leading to enhanced user satisfaction and engagement.",
      points: [
        "User research and persona development.",
        "Wireframing, prototyping, and user testing.",
        "Information architecture and user flow design.",
        "Visual design and branding.",
        "Accessibility and usability testing."
      ],
      mockupImage: "/img/services_img/10/4.png",
    },
    benefits: {
      desc: "Effective UI/UX design leads to higher user satisfaction, increased conversion rates, and reduced development costs by identifying issues early. Our designs ensure your product is intuitive, enjoyable, and meets user expectations.",
      metrics: [
        {
          title: "User Satisfaction",
          value: "40%",
          extra: "increase",
        },
        {
          title: "Conversion Rate",
          value: "25%",
          extra: "improvement",
        },
      ],
    },
    process: [
        {
            id: 1,
            title: "Discovery & Planning",
            description: "We begin by conducting thorough research into your target users, business objectives, and market trends. This phase involves stakeholder interviews, user surveys, and competitive analysis to define the design strategy and project goals."
        },
        {
            id: 2,
            title: "Design & Prototyping",
            description: "Our team translates insights into intuitive designs, creating wireframes, mockups, and interactive prototypes. We focus on user flows, information architecture, and visual aesthetics to ensure a seamless and engaging user experience."
        },
        {
            id: 3,
            title: "Development & Testing",
            description: "We collaborate closely with development teams to ensure design integrity during implementation. Our designers conduct usability testing, A/B testing, and gather user feedback to iterate and refine the design, ensuring it meets both user needs and business goals."
        },
        {
            id: 4,
            title: "Deployment & Training",
            description: "We assist in the smooth handover of design assets and guidelines to your development team. We also provide comprehensive documentation and support to ensure consistent implementation and future scalability of the UI/UX design across all platforms."
        }
    ],
    features: [
      {
        id: 1,
        title: "User-Centered Design",
        sub_features: [
          "User research and analysis",
          "Persona creation and user journey mapping",
          "Usability testing and feedback integration"
        ]
      },
      {
        id: 2,
        title: "Visual Design",
        sub_features: [
          "Wireframing and prototyping",
          "High-fidelity mockups",
          "Design systems and style guides"
        ]
      },
    ],
    technologies: [
      { name: "Figma", icon: <FaHtml5 className="text-purple-500 text-3xl" /> },
      { name: "Sketch", icon: <FaJs className="text-orange-500 text-3xl" /> },
      { name: "Adobe XD", icon: <FaReact className="text-pink-500 text-3xl" /> },
    ],
    testimonials: [
        {
            id: 1,
            quote: "Techvelly's UI/UX design team delivered an exceptional product. Their attention to detail and understanding of user needs resulted in a truly intuitive and beautiful interface.",
            author: "Sarah Chen",
            title: "Product Manager, Innovate Corp."
        }
    ],
    faq: [
        {
            id: 1,
            question: "What is the difference between UI and UX design?",
            answer: "UI (User Interface) design focuses on the visual and interactive elements of a product, while UX (User Experience) design encompasses the entire journey a user takes with a product, ensuring it is efficient and enjoyable."
        },
        {
            id: 2,
            question: "How do you ensure a user-friendly design?",
            answer: "We employ a user-centered design approach, conducting thorough user research, creating prototypes, and performing usability testing to gather feedback and iterate on designs until optimal user-friendliness is achieved."
        }
    ]
  },
  {
    id: 11,
    title: 'Full Cycle Product Development',
    category: 'Software Development',
    description: 'End-to-end development from concept to launch. We take your idea and turn it into a successful product, covering all stages of development.',
    image: '/img/services_img/11/1.png',
    sub_headers: {
      title: "Full Cycle Product Development",
      sub_points: [
        "End-to-end development.",
        "From concept to launch.",
        "Covering all stages of development.",
        "Turning your idea into a successful product."
      ],
      mockupImage: "/img/services_img/11/2.png",
    },
    problem: {
      challenges: [
        "Managing the entire product lifecycle from ideation to launch and post-launch support.",
        "Aligning product development with market needs and business objectives.",
        "Ensuring seamless integration of various development phases and technologies."
      ],
      mockupImage: "/img/services_img/11/3.png",
    },
    solutions: {
      desc: "We offer end-to-end product development services, guiding you through every stage from concept validation and design to development, testing, deployment, and ongoing maintenance. Our holistic approach ensures a cohesive and successful product launch.",
      points: [
        "Market research and feasibility studies.",
        "Product strategy and roadmap development.",
        "UI/UX design and prototyping.",
        "Full-stack development and quality assurance.",
        "Deployment, maintenance, and continuous improvement."
      ],
      mockupImage: "/img/services_img/11/4.png",
    },
    benefits: {
      desc: "Our full-cycle product development services provide a streamlined process, reducing time-to-market and ensuring a high-quality product that meets user demands. We help you bring innovative ideas to life efficiently and effectively.",
      metrics: [
        {
          title: "Time to Market",
          value: "30%",
          extra: "reduction",
        },
        {
          title: "Product Quality",
          value: "25%",
          extra: "improvement",
        },
        {
          title: "User Adoption",
          value: "40%",
          extra: "increase",
        },
      ],
    },
    process: [
        {
            id: 1,
            title: "Discovery & Planning",
            description: "We kick off by thoroughly analyzing your product idea, market potential, and target audience. This phase involves comprehensive research, feasibility studies, and strategic planning to define a robust product roadmap and business model."
        },
        {
            id: 2,
            title: "Design & Prototyping",
            description: "Our design team crafts compelling user interfaces and experiences, focusing on usability and aesthetic appeal. We develop wireframes, interactive prototypes, and conduct user testing to validate concepts and ensure the product resonates with its intended users."
        },
        {
            id: 3,
            title: "Development & Testing",
            description: "Our engineering team develops the product using agile methodologies, ensuring iterative progress and flexibility. We integrate robust testing protocols throughout the development lifecycle, including unit, integration, system, and user acceptance testing, to guarantee a high-quality, stable, and secure product."
        },
        {
            id: 4,
            title: "Deployment & Training",
            description: "We manage the product launch, including deployment to production environments and setting up continuous integration/continuous delivery (CI/CD) pipelines. We also provide comprehensive training for your team and ongoing support to ensure successful adoption and long-term product evolution."
        }
    ],
    features: [
      {
        id: 1,
        title: "Strategic Planning",
        sub_features: [
          "Market analysis and competitive research",
          "Business model canvas and value proposition",
          "Technology stack consultation"
        ]
      },
      {
        id: 2,
        title: "Development & Launch",
        sub_features: [
          "Agile development methodologies",
          "Continuous integration and delivery",
          "Post-launch support and optimization"
        ]
      },
    ],
    technologies: [
      { name: "React", icon: <FaReact className="text-blue-500 text-3xl" /> },
      { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
      { name: "AWS/Azure/GCP", icon: <FaHtml5 className="text-orange-500 text-3xl" /> },
      { name: "Docker/Kubernetes", icon: <FaJs className="text-yellow-400 text-3xl" /> },
    ],
    testimonials: [
        {
            id: 1,
            quote: "Techvelly provided exceptional full-cycle product development, turning our vision into a market-ready product with efficiency and expertise. Their team was instrumental in our success.",
            author: "Michael Brown",
            title: "CTO, Startup Innovations"
        }
    ],
    faq: [
        {
            id: 1,
            question: "What is included in full-cycle product development?",
            answer: "Full-cycle product development includes everything from initial concept and strategy, UI/UX design, development, testing, deployment, and ongoing maintenance and support."
        },
        {
            id: 2,
            question: "How do you ensure the product meets market demands?",
            answer: "We conduct thorough market research, competitive analysis, and user feedback sessions throughout the development process to ensure the product is aligned with market needs and user expectations."
        }
    ]
  },
  {
    id: 12,
    title: 'SaaS Product Development',
    category: 'Software Development',
    description: 'Scalable SaaS solutions for modern business challenges. We build multi-tenant and secure SaaS products that are ready to scale.',
    image: '/img/services_img/12/1.png',
    sub_headers: {
      title: "SaaS Product Development",
      sub_points: [
        "Scalable SaaS solutions.",
        "For modern business challenges.",
        "Multi-tenant and secure.",
        "Ready to scale."
      ],
      mockupImage: "/img/services_img/12/2.png",
    },
    problem: {
      challenges: [
        "Designing multi-tenant architectures that ensure data isolation and security for all users.",
        "Building scalable infrastructure to handle a growing user base and data volume.",
        "Implementing robust subscription and billing management systems."
      ],
      mockupImage: "/img/services_img/12/3.png",
    },
    solutions: {
      desc: "We specialize in developing robust and scalable SaaS solutions tailored to your business model. Our expertise covers multi-tenancy, secure data handling, flexible subscription models, and seamless third-party integrations, ensuring your SaaS product is ready for market and growth.",
      points: [
        "Multi-tenant architecture design and implementation.",
        "Scalable cloud infrastructure (AWS, Azure, GCP).",
        "Subscription and billing management integration.",
        "Advanced security protocols and compliance.",
        "API development for seamless integrations."
      ],
      mockupImage: "/img/services_img/12/4.png",
    },
    benefits: {
      desc: "Our SaaS product development services enable businesses to achieve recurring revenue, expand market reach, and reduce operational costs. We deliver secure, scalable, and feature-rich SaaS applications that drive business growth.",
      metrics: [
        {
          title: "Recurring Revenue",
          value: "40%",
          extra: "increase",
        },
        {
          title: "Market Reach",
          value: "35%",
          extra: "expansion",
        },
        {
          title: "Operational Cost",
          value: "20%",
          extra: "reduction",
        },
      ],
    },
    process: [
        {
            id: 1,
            title: "Discovery & Planning",
            description: "We start by thoroughly analyzing your SaaS vision, target market, and competitive landscape. This phase involves in-depth consultations, defining key features, user stories, and outlining a strategic roadmap for your scalable SaaS product."
        },
        {
            id: 2,
            title: "Design & Prototyping",
            description: "Our UI/UX team designs intuitive and scalable interfaces optimized for multi-tenant architectures. We create detailed wireframes, mockups, and interactive prototypes, ensuring a seamless and engaging experience for all your SaaS users."
        },
        {
            id: 3,
            title: "Development & Testing",
            description: "Our expert developers build your SaaS platform with a focus on scalability, security, and performance, utilizing cloud-native technologies. We implement rigorous testing, including security audits, load testing, and functional testing, to ensure a robust and reliable product ready for market."
        },
        {
            id: 4,
            title: "Deployment & Training",
            description: "We manage the secure deployment of your SaaS application to cloud infrastructure, ensuring high availability and seamless integration. We also provide comprehensive training and documentation for your team, along with ongoing support and maintenance to guarantee continuous operation and customer satisfaction."
        }
    ],
    features: [
      {
        id: 1,
        title: "Scalable Architecture",
        sub_features: [
          "Multi-tenant data architecture",
          "Cloud-native development",
          "Microservices and serverless functions"
        ]
      },
      {
        id: 2,
        title: "Monetization & Management",
        sub_features: [
          "Subscription and billing management",
          "User and role management",
          "Analytics and reporting dashboards"
        ]
      },
    ],
    technologies: [
      { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
      { name: "Python", icon: <FaPython className="text-blue-500 text-3xl" /> },
      { name: "React", icon: <FaReact className="text-blue-500 text-3xl" /> },
      { name: "AWS/Azure/GCP", icon: <FaHtml5 className="text-orange-500 text-3xl" /> },
    ],
    testimonials: [
        {
            id: 1,
            quote: "Techvelly developed a highly scalable and secure SaaS platform for us, which has been pivotal to our business growth. Their expertise in SaaS architecture is truly impressive.",
            author: "Chris Johnson",
            title: "CEO, Cloud Solutions Ltd."
        }
    ],
    faq: [
        {
            id: 1,
            question: "What is multi-tenancy in SaaS?",
            answer: "Multi-tenancy is an architecture where a single instance of a software application serves multiple customers (tenants). Each tenant's data is isolated and remains invisible to other tenants."
        },
        {
            id: 2,
            question: "How do you ensure the security of SaaS applications?",
            answer: "We implement robust security measures including data encryption, access controls, regular security audits, and compliance with industry standards like GDPR and HIPAA."
        }
    ]
  }
];